import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuthedApi, errMsg } from "../../lib/api";
import StateCitySelect from "../StateCitySelect";
import ImageUploader from "../ImageUploader";

export default function StoreEditor({ dealer, onSaved }) {
  const api = useAuthedApi();
  const [f, setF] = useState({ name: "", logo_url: "", banner_url: "", address: "", state: "", city: "", phone: "", about: "", established: "", ...(dealer || {}) });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    if (!f.state || !f.city) return toast.error("Select your store's state and city");
    setBusy(true);
    try {
      const { name, logo_url, banner_url, address, state, city, phone, about, established } = f;
      const d = await api("put", "/dealers/me", { name, logo_url, banner_url, address, state, city, phone, about, established: established ? Number(established) : null });
      onSaved(d);
      toast.success("Dealer store saved");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <form onSubmit={save} className="lux-card p-6 sm:p-8 space-y-6 max-w-3xl" data-testid="store-editor">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><p className="eyebrow">Pre-owned dealer store</p><p className="text-sm text-gray-400 mt-1">Your logo, store name and showroom details appear on every car you list as a dealer.</p></div>
        {dealer && <Link to={`/dealers/${dealer.id}`} className="btn-outline text-xs !py-2" data-testid="view-my-store">View my store</Link>}
      </div>
      <div className="grid sm:grid-cols-[200px_1fr] gap-6">
        <div><label className="lux-label">Logo</label><ImageUploader value={f.logo_url ? [f.logo_url] : []} onChange={(fn) => setF((p) => ({ ...p, logo_url: fn(p.logo_url ? [p.logo_url] : []).slice(-1)[0] || "" }))} max={1} testid="store-logo" /></div>
        <div><label className="lux-label">Store banner</label><ImageUploader value={f.banner_url ? [f.banner_url] : []} onChange={(fn) => setF((p) => ({ ...p, banner_url: fn(p.banner_url ? [p.banner_url] : []).slice(-1)[0] || "" }))} max={1} testid="store-banner" /></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><label className="lux-label">Dealer / store name</label><input className="lux-input" required value={f.name} onChange={set("name")} data-testid="store-name" /></div>
        <div><label className="lux-label">Store phone</label><input className="lux-input" required pattern="[0-9+ ]{10,15}" value={f.phone} onChange={set("phone")} data-testid="store-phone" /></div>
        <StateCitySelect state={f.state} city={f.city} prefix="store-" onChange={(v) => setF({ ...f, ...v })} />
        <div className="sm:col-span-2"><label className="lux-label">Showroom address</label><input className="lux-input" required value={f.address} onChange={set("address")} data-testid="store-address" /></div>
        <div><label className="lux-label">Established (year)</label><input className="lux-input" type="number" value={f.established || ""} onChange={set("established")} data-testid="store-established" /></div>
      </div>
      <div><label className="lux-label">About the store</label><textarea className="lux-textarea" rows={4} value={f.about} onChange={set("about")} data-testid="store-about" /></div>
      <button className="btn-gold" disabled={busy} data-testid="store-save-button">{busy ? "Saving..." : dealer ? "Save store" : "Create dealer store"}</button>
    </form>
  );
}
